<template>
  <CModal
    class="variant-modal"
    title="Variant Management"
    color="white"
    size="xl"
    centered
    :show.sync="$store.state.menuV2.variantManagementModalShow"
    :closeOnBackdrop="false"
  >
    <div class="variant-management">
      <div class="row">
        <!-- Varyant Listesi -->
        <div class="col-md-4 variant-list-container">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="mb-0">Variants</h5>
            <CButton
              color="success"
              size="sm"
              @click="addNewVariant"
              :disabled="submitted"
              shape="pill"
            >
              <CIcon name="cil-plus" /> Add New
            </CButton>
          </div>

          <div class="variant-list" ref="variantList">
            <div
              v-for="variant in variants"
              :key="variant.id"
              class="variant-item"
              :class="{'active': selectedVariant && selectedVariant.id === variant.id}"
              @click="selectVariant(variant)"
              :data-variant-id="variant.id"
            >
              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                  <CIcon name="cil-move" class="variant-handle mr-2" />
                  <div>
                    <h6 class="mb-0">{{ variant.name }}</h6>
                    <small v-if="variant.description" class="text-muted">{{ variant.description | truncate(90) }}</small>
                  </div>
                </div>
                <div class="d-flex flex-column align-items-end">
                  <span class="badge" :class="[variant.price_adjustment > 0 ? 'badge-success' : 'badge-light']">
                    {{ parseFloat(variant.price) | toCurrency }}
                  </span>
                  <small v-if="variant.sold_out" class="text-danger mr-1">Sold Out</small>
                </div>
              </div>
            </div>

            <div v-if="variants.length === 0" class="text-center py-4">
              <CIcon name="cil-tag" size="xl" class="text-muted mb-2" />
              <p class="text-muted">No variants found. Create your first variant!</p>
            </div>
          </div>
        </div>

        <!-- Varyant Detayları -->
        <div class="col-md-8 variant-detail-container">
          <div v-if="selectedVariant || isAddingNew">
            <h5 class="mb-3">{{ isAddingNew ? 'New Variant' : 'Edit Variant' }}</h5>

            <CForm>
              <CRow>
                <CCol lg="6">
                  <CInput
                    label="Name"
                    placeholder="Variant name"
                    :value.sync="form.name"
                    :isValid="$globalFunc.checkIfValid($v.form, 'name')"
                    :lazy="false"
                    invalidFeedback="Name is required"
                  />
                </CCol>

                <CCol lg="6">
                  <div class="d-flex flex-md-row flex-column flex-gap-2">
                    <CInput
                      class="flex-grow-1"
                      label="Price"
                      placeholder="0.00"
                      type="number"
                      step="0.10"
                      :value.sync="form.price"
                      :isValid="$globalFunc.checkIfValid($v.form, 'price')"
                      :lazy="false"
                      invalidFeedback="Price is required"
                    >
                      <template #prepend-content><CIcon name="cil-euro"/></template>
                    </CInput>

                    <CInput
                      v-if="this.usetoprice === true"
                      label="Takeout Price"
                      placeholder="0.00"
                      type="number"
                      step="0.10"
                      :value.sync="form.toPrice"
                      :isValid="$globalFunc.checkIfValid($v.form, 'toPrice')"
                      :lazy="false"
                      invalidFeedback="Takeout price is required"
                    >
                      <template #prepend-content><CIcon name="cil-euro"/></template>
                    </CInput>
                  </div>
                </CCol>

                <CCol md="12">
                  <CTextarea
                    label="Description"
                    placeholder="Variant description"
                    :value.sync="form.description"
                    rows="3"
                  />
                </CCol>

                <CCol md="12">
                  <div class="form-group">
                    <label>Sold Out</label>
                    <div>
                      <CSwitch
                        labelOn="Yes"
                        labelOff="No"
                        color="danger"
                        shape="pill"
                        :checked.sync="form.sold_out"
                      />
                    </div>
                  </div>
                </CCol>
              </CRow>

              <div class="d-flex justify-content-between mt-4">
                <div>
                  <div v-if="pendingDelete" class="d-flex align-items-center flex-gap-1">
                    <span class="text-danger">Are you sure?</span>
                    <CButton size="sm" color="link" @click="deleteVariant">
                      <CIcon name="cil-check-alt" />
                    </CButton>
                    <CButton size="sm" color="link" @click="pendingDelete = false">
                      <CIcon name="cil-x" />
                    </CButton>
                  </div>

                  <CButton v-else-if="!isAddingNew" size="sm" color="danger" variant="ghost" shape="pill" @click="pendingDelete = true">
                    <CIcon name="cil-trash" /> Delete
                  </CButton>
                </div>

                <div>
                  <CButton size="sm" color="link" class="mr-2" @click="cancelEdit" :disabled="submitted">
                    Cancel
                  </CButton>

                  <CButton size="sm" color="success" @click="saveVariant" :disabled="submitted">
                    <CIcon name="cil-save" /> Save
                  </CButton>
                </div>
              </div>
            </CForm>
          </div>

          <div v-else class="empty-state">
            <div class="text-center py-5">
              <CIcon name="cil-tag" size="3xl" class="text-muted mb-3" />
              <h5>No Variant Selected</h5>
              <p class="text-muted">Select a variant from the list or create a new one.</p>
              <CButton
                color="success"
                @click="addNewVariant"
                :disabled="submitted"
              >
                <CIcon name="cil-plus" /> Add New Variant
              </CButton>
            </div>
          </div>
        </div>
      </div>
    </div>

    <CElementCover :opacity="0.4" v-show="loading || submitted"/>

    <template #footer class="p-1">
      <CButton @click="closeModal" color="secondary">Close</CButton>
    </template>
  </CModal>

</template>

<script>
import { validationMixin } from "vuelidate"
import { required } from "vuelidate/lib/validators"
import Sortable from "sortablejs"

export default {
  name: "VariantManagementModal",

  mixins: [validationMixin],

  props: {
    menuId: { type: [Number, String], default: null },
    menuVariants: { type: Array, default: () => null },
    usetoprice: { type: Boolean, default: false }
  },

  data() {
    return {
      loading: false,
      submitted: false,
      variants: [],
      selectedVariant: null,
      isAddingNew: false,
      form: {
        name: '',
        description: '',
        price: 0,
        toPrice: 0,
        sold_out: false
      },
      sortable: null,
      pendingDelete: false
    }
  },

  computed: {
    restaurantId() {
      return this.$route.params.restaurant_id;
    }
  },

  validations: {
    form: {
      name: { required },
      price: { required },
      toPrice: { required }
    }
  },

  watch: {
    '$store.state.menuV2.variantManagementModalShow': {
      handler(newVal) {
        if (newVal) {
          this.loadVariants();
          this.$nextTick(() => {
            this.initSortable();
          });
        }
      },
      immediate: true
    },
    pendingDelete(newVal) {
      if (newVal) {
        this.timer = setTimeout(() => {
          this.pendingDelete = false;
        }, 3000);
      } else {
        clearInterval(this.timer);
      }
    }
  },

  methods: {
    async loadVariants() {
      if (this.menuVariants && false) {
        this.variants = [...this.menuVariants].sort((a, b) => a.display_order - b.display_order);
      } else {
        const response = await this.$axios.get(this.$backend.MENU_V2.GET_VARIANTS(this.restaurantId, this.menuId));
        this.variants = response.data;
      }
    },

    initSortable() {
      if (this.$refs.variantList) {
        if (this.sortable) {
          this.sortable.destroy();
        }

        this.sortable = Sortable.create(this.$refs.variantList, {
          handle: ".variant-handle",
          animation: 150,
          ghostClass: "variant-item-ghost",
          chosenClass: "variant-item-chosen",
          dragClass: "variant-item-drag",
          onEnd: this.onSortEnd
        });
      }
    },

    onSortEnd(evt) {
      const { oldIndex, newIndex } = evt;
      if (oldIndex === newIndex) return;

      // Varyantları yeniden sırala
      const movedVariant = this.variants.splice(oldIndex, 1)[0];
      this.variants.splice(newIndex, 0, movedVariant);

      // Yeni sıra numaralarını güncelle
      this.variants.forEach((variant, index) => {
        variant.display_order = index;
      });

      // Backend'e yeni sıralamayı kaydet
      this.updateVariantOrders();
    },

    async updateVariantOrders() {
      this.loading = true;

      try {
        // Her varyant için display_order değerini güncelle
        const updatePromises = this.variants.map(variant =>
          this.$axios.put(
            this.$backend.MENU_V2.UPDATE_VARIANT(this.restaurantId, this.menuId, variant.id),
            { display_order: variant.display_order }
          )
        );

        await Promise.all(updatePromises);

        // Varyant listesini güncelle
        this.$root.$emit('variants-updated');
      } catch (error) {
        console.error('Failed to update variant orders:', error);
        this.$toast.error('Failed to update variant orders');
      } finally {
        this.loading = false;
      }
    },



    selectVariant(variant) {
      this.selectedVariant = variant;
      this.isAddingNew = false;

      // Form alanlarını doldur
      this.form = {
        name: variant.name,
        description: variant.description || '',
        price: parseFloat(variant.price),
        toPrice: parseFloat(variant.toPrice),
        sold_out: variant.sold_out === 1
      };

      // Validasyon hatalarını temizle
      this.$v.form.$reset();
    },

    addNewVariant() {
      this.selectedVariant = null;
      this.isAddingNew = true;

      // Form alanlarını temizle
      this.form = {
        name: '',
        description: '',
        price: 0,
        toPrice: 0,
        sold_out: false
      };

      // Validasyon hatalarını temizle
      this.$v.form.$reset();
    },

    cancelEdit() {
      if (this.isAddingNew) {
        this.isAddingNew = false;
      } else {
        this.selectedVariant = null;
        // this.selectVariant(this.selectedVariant);
      }
    },

    async saveVariant() {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return;
      }

      this.submitted = true;

      try {
        if (this.isAddingNew) {
          await this.createVariant();
        } else {
          await this.updateVariant();
        }

        await this.loadVariants();
        this.$root.$emit('variants-updated');

        // Formu temizle
        this.isAddingNew = false;
        this.selectedVariant = null;

        this.$toast.success(`Variant ${this.isAddingNew ? 'created' : 'updated'} successfully`);
      } catch (error) {
        this.$toast.error(`Failed to ${this.isAddingNew ? 'create' : 'update'} variant`);
        console.error(error);
      } finally {
        this.submitted = false;
      }
    },

    async createVariant() {
      const payload = {
        name: this.form.name,
        description: this.form.description,
        price: this.form.price,
        toPrice: this.form.toPrice,
        sold_out: this.form.sold_out ? 1 : 0
      };

      await this.$axios.post(this.$backend.MENU_V2.CREATE_VARIANT(this.restaurantId, this.menuId), payload);
    },

    async updateVariant() {
      const payload = {
        name: this.form.name,
        description: this.form.description,
        price: this.form.price,
        toPrice: this.form.toPrice,
        sold_out: this.form.sold_out ? 1 : 0
      };

      await this.$axios.put(
        this.$backend.MENU_V2.UPDATE_VARIANT(this.restaurantId, this.menuId, this.selectedVariant.id),
        payload
      );
    },

    async deleteVariant() {
      if (!this.selectedVariant) return;

      this.submitted = true;

      try {
        await this.$axios.delete(
          this.$backend.MENU_V2.DELETE_VARIANT(this.restaurantId, this.menuId, this.selectedVariant.id)
        );

        await this.loadVariants();
        this.$root.$emit('variant-deleted', this.selectedVariant.id);

        this.selectedVariant = null;
        this.pendingDelete = false;

        this.$toast.success('Variant deleted successfully');
      } catch (error) {
        this.$toast.error('Failed to delete variant');
        console.error(error);
      } finally {
        this.submitted = false;
      }
    },

    closeModal() {
      this.$store.state.menuV2.variantManagementModalShow = false;
      this.selectedVariant = null;
      this.isAddingNew = false;

      // Ana sayfadaki varyant listesini güncellemek için event gönder
      this.$root.$emit('variants-updated');
    }
  }
}
</script>

<style scoped>
.variant-management {
  min-height: 376px;
}

.variant-list-container {
  border-right: 1px solid #eee;
  padding-right: 20px;
}

.variant-list {
  max-height: 500px;
  overflow-y: auto;
}

.variant-item {
  padding: 12px;
  border: 1px solid #eee;
  border-radius: 8px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.variant-item:hover {
  background-color: #f8f9fa;
  transform: translateY(-2px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}

.variant-item.active {
  background-color: #e8f4ff;
  border-color: #20a8d8;
}

.variant-handle {
  cursor: move;
  color: #aaa;
}

.variant-item:hover .variant-handle {
  color: #666;
}

.variant-item-ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.variant-item-chosen {
  background-color: #e8f4ff;
  border-color: #20a8d8;
}

.variant-item-drag {
  background-color: #e8f4ff;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.variant-detail-container {
  padding: 0 20px;
}

.empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 300px;
  color: #6c757d;
}

.badge {
  padding: 5px 8px;
  border-radius: 4px;
  font-weight: 500;
}
</style>
